import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export const fieldsChatAudit = _extends({}, fieldsIBaseModel, {
  lastMessage: {
    type: 'ID',
    ref: EModel.Message
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  },
  readAt: {
    type: 'Date'
  },
  reader: {
    type: 'ID',
    ref: EModel.User
  }
});